export default __webpack_public_path__ + "static/media/single-project-page-01-img16.7d4f00ec.png";